import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=4fb65b37&scoped=true&"
import script from "./AppBody.vue?vue&type=script&lang=js&"
export * from "./AppBody.vue?vue&type=script&lang=js&"
import style0 from "./AppBody.vue?vue&type=style&index=0&id=4fb65b37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb65b37",
  null
  
)

export default component.exports